module.exports = __webpack_public_path__ + "static/media/trashG.f948e914.png";